import { CREATE_WIDGET } from "./actionTypes";
import { setUpAndOpenFreshdeskWidget } from "./widget";

export const createWidget = (user, created) => async dispatch => {
  setUpAndOpenFreshdeskWidget(user, created);
  dispatch({ type: CREATE_WIDGET, payload: true });
};
